export default __webpack_public_path__ + "static/media/Smetana.e7da72f1.gif";